import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const location = useLocation();

  return (
    <header id="header" className="default default-light default-new">
      <div className="menu header-navbar-v2">
        <nav id="menu" className="mega-menu">
          <section className="menu-list-items">
            <div className="container">
              <div className="row">
                <div className="col-md-12 position-relative">
                  <div className="header-inner">
                    <ul className="menu-logo">
                      <li>
                        <Link to="/" className="logo d-none d-lg-block">
                          <img id="logo_img" src="images/The-Key-Logo.png" alt="The Key Valet Parking Service" />
                        </Link>
                        <Link to="/" className="mobile-logo d-lg-none">
                          <img id="logo_img" src="images/The-Key-Logo.png" alt="The Key Valet Parking Service" />
                        </Link>
                        <div className="menu-mobile-collapse-trigger d-lg-none"><span></span></div>
                      </li>
                    </ul>
                    <ul className="menu-links">
                      <li className={`mega-menu-item ${location.pathname === '/' ? 'active' : ''}`}>
                        <Link to="/">Home</Link>
                      </li>
                      <li className={`mega-menu-item ${location.pathname === '/about-us' ? 'active' : ''}`}>
                        <Link to="/about-us">About Us</Link>
                      </li>
                      <li className={`mega-menu-item ${location.pathname === '/terms-and-conditions' ? 'active' : ''}`}>
                        <Link to="/terms-and-conditions">Terms of Use</Link>
                      </li>
                      <li className={`mega-menu-item ${location.pathname === '/privacy-policy' ? 'active' : ''}`}>
                        <Link to="/privacy-policy">Privacy Policy</Link>
                      </li>
                      <li className={`mega-menu-item ${location.pathname === '/contact-us' ? 'active' : ''}`}>
                        <Link to="/contact-us">Contact Us</Link>
                      </li>
                    </ul>
                    {/* <div className="header-button">
                      <Link className="button" to="/tracking">Request Car</Link>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </nav>
      </div>
    </header>
    
  );
}

export default Header;
